import { Dropdown } from "primereact/dropdown";
import { Tree } from "primereact/tree";
import { useEffect, useState } from "react";
import { useParams,useNavigate } from "react-router-dom";
import RouteDetails from "../../../../services/AuraCamera/routes/route_details";
import Helpers from "../../../../utils/helpers";

const Index = () => {
  var navigate = useNavigate();
  const { siteID } = useParams();
  const [SiteName, UpdateSiteName] = useState<any>([]);
  const [FullRouteTree, UpdateFullRouteTree] = useState<any>([]);
  const [RouteObject, UpdateRouteObject] = useState<any>([]);
  const [KeyRouteExpand, UpdateKeyRouteExpand] = useState<any>([]);
  const [MasterRouteObject, UpdateMasterRouteObject] = useState<any>([]);
  const [SelectedRoute, UpdateSelectedRoute] = useState<any>([]);
  useEffect(() => {
    let route_level_tree: any = [];
    let route_brief_only: any = [{ key: "all", name: "All Routes" }];
    let temp_obj: any = {};

    RouteDetails.GetRouteDetails(siteID).then((route_details_res: any) => {
      UpdateSiteName(route_details_res[0]?.siteName);
      route_details_res?.forEach((val: any,index:any) => {
        let obs_object: any = [];
        let temp_route_name = val.routeName;
        let temp_route_id = index;
        temp_obj[`${temp_route_id}`] = true;
        let display_target_x = 1;
        val?.obs_sequence_targets?.forEach(
          (route_details_val: any, ind: any) => {
            let temp_target_obj = [];
            for (let x = 1; x <= route_details_val; x++) {
              temp_target_obj.push({
                key: Helpers.generateRandomNumber(10000, 99999),
                label: "Target " + display_target_x++,
                data: "Target Data",
                icon: "fa fa-map-pin",
              });
            }

            obs_object.push({
              key: Helpers.generateRandomNumber(10000, 99999),
              label: "observation " + ++ind,
              data: "Observation Data",
              icon: "fa fa-sitemap",
              children: temp_target_obj,
            });
          }
        );
        route_level_tree.push({
          key: temp_route_id,
          label: temp_route_name,
          data: "Route Data",
          icon: "fa fa-random",
          children: obs_object,
        });
        route_brief_only.push({
          key: temp_route_id,
          name: temp_route_name,
        });
        UpdateRouteObject(route_brief_only);
      });
      UpdateFullRouteTree(route_level_tree);
      UpdateMasterRouteObject(route_level_tree);

      UpdateSelectedRoute({ key: "all", name: "All Routes" });

      UpdateKeyRouteExpand(temp_obj);
    });
  }, []);

  const handleRouteDropDown = (e: any) => {
    UpdateSelectedRoute(e);
    if (e?.key == "all") {
      UpdateFullRouteTree(MasterRouteObject);
    } else {
      let filtered_Route: any = MasterRouteObject.filter(
        (val: any, ind: any) => {
          if (val?.key == e?.key) {
            return true;
          }
        }
      );
      UpdateFullRouteTree(filtered_Route);
    }
  };

  return (
    <>
      <nav aria-label="breadcrumb" className="breadcrumb--wrapper">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a onClick={()=>{
              navigate(`/aura-camera/operations`);
            }}>{"Operations"}</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            <a>{"Site Route Details"}</a>
          </li>
        </ol>
      </nav>

      <div className="content__header">
        <div className="content__wrap">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h4 className="page-heading">
                {"Site Route Details - " + SiteName}
              </h4>
            </div>
          </div>
        </div>
      </div>
      {/* Main Box Start */}
      <div className="content__boxed dashboard_aogi_content_box_first">
        <div className="content__wrap">
          <div className="dashboard_main_grid_div route-header">
            <Dropdown
              className="surveyDropdown"
              value={SelectedRoute}
              options={RouteObject}
              onChange={(e: any) => {
                handleRouteDropDown(e.target.value);
              }}
              optionLabel="name"
              filter
              filterBy="name"
              placeholder={"Select Route"}
            />

            <div className="card all-surveys-table">
              <Tree
                value={FullRouteTree}
                expandedKeys={KeyRouteExpand}
                onToggle={(e: any) => UpdateKeyRouteExpand(e.value)}
                className="w-full md:w-30rem"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Main Box End */}
    </>
  );
};

export default Index;
